import { render, staticRenderFns } from "./TTextArea.vue?vue&type=template&id=66fe7616&scoped=true&"
import script from "./TTextArea.vue?vue&type=script&lang=js&"
export * from "./TTextArea.vue?vue&type=script&lang=js&"
import style0 from "./TTextArea.vue?vue&type=style&index=0&id=66fe7616&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "66fe7616",
  null
  
)

/* custom blocks */
import block0 from "./TTextArea.vue?vue&type=custom&index=0&blockType=docs"
if (typeof block0 === 'function') block0(component)

export default component.exports